import { render, staticRenderFns } from "./SeatArea.vue?vue&type=template&id=54d7b10a"
import script from "./SeatArea.vue?vue&type=script&lang=js"
export * from "./SeatArea.vue?vue&type=script&lang=js"
import style0 from "./SeatArea.vue?vue&type=style&index=0&id=54d7b10a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports